<app-text [alias]="'grading_rules_component'"></app-text>
<app-button-list>
    <app-button (clickedEvent)="show()">Add Grading Rule </app-button>
</app-button-list>
<mat-card>
    <mat-card-content>
        <app-table-filter [tableName]="tableName" [filterItems]="filters"></app-table-filter>
    </mat-card-content>
</mat-card>
<app-table [tableName]="tableName" [baseUrl]="baseUrl" [columns]="columns"></app-table>